import React from "react";
import { useTranslation } from "../../context/TranslationContext";
import { Truck, Package, Warehouse, Globe } from "lucide-react";
import Section from "../ui/Section";
import InfoCard from "../ui/InfoCard";

const Services: React.FC = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: <Truck className="w-6 h-6" />,
      title: t("services.road.title"),
      description: t("services.road.description"),
    },
    {
      icon: <Package className="w-6 h-6" />,
      title: t("services.express.title"),
      description: t("services.express.description"),
    },
    {
      icon: <Warehouse className="w-6 h-6" />,
      title: t("services.warehousing.title"),
      description: t("services.warehousing.description"),
    },
    {
      icon: <Globe className="w-6 h-6" />,
      title: t("services.international.title"),
      description: t("services.international.description"),
    },
  ];

  return (
    <Section id="services">
      <div className="text-center mb-12">
        <h2 className="headline text-neutral mb-6">{t("services.title")}</h2>
        <p className="section-description mx-auto">
          {t("services.description")}
        </p>
      </div>

      <div className="relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-[900px] mx-auto">
          {services.map((service, index) => (
            <InfoCard
              title={service.title}
              description={service.description}
              variant="default"
            />
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Services;
